// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@progress/kendo-theme-material/dist/all.css'
import './lib/css'
import './lib/script'
import './lib/global'
require('src/assets/js/axiosInit')

import Vue from 'vue'
import { mapState } from 'vuex'
import App from './App'
import router from './router'
import EventBus from './lib/eventBus.js'
import axios from 'axios'
import store from './vuex/store'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import VCalendar from 'v-calendar/src/lib'
import _ from 'lodash'
import Meta from 'vue-meta'
import { Grid } from '@progress/kendo-vue-grid'
import { LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl'

import 'assets/style/global.scss'
import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import '../node_modules/toastr/build/toastr.min.css'

// eslint-disable-next-line no-extend-native,no-new-symbol
Array.prototype.replaceItem = function (index, item) {
	if (arguments.length === 1) {
		return [
			...this.slice(0, index),
			...this.slice(index + 1)
		]
	}

	return [
		...this.slice(0, index),
		item,
		...this.slice(index + 1)
	]
}

Vue.use(Meta, {
	keyName: 'metaInfo',
	attribute: 'data-vue-meta',
	ssrAttribute: 'data-vue-meta-server-rendered',
	tagIDKeyName: 'vmid',
	refreshOnceOnNavigation: true
})

Vue.use(VCalendar, {
	componentPrefix: 'vc'
})

global.toastr = require('toastr')

moment.locale('ru')

Vue.prototype._ = _
Vue.prototype.$bus = EventBus
Vue.prototype.$http = axios
Vue.prototype.$moment = moment
Vue.prototype.$log = console.log
Vue.use(Loading)

const esMessages = {
	'datepicker': {
		'toggleCalendar': 'Календарь'
	},
	'calendar': {
		'today': 'Сегодня'
	},
	'dateinput': {
		'increment': 'Начало',
		'decrement': 'Конец'
	},
	'numerictextbox': {
		'increment': 'С',
		'decrement': 'По'
	},
	'numbers': {
		'increment': 'С',
		'decrement': 'По'
	},
	'grid': {
		'groupPanelEmpty': 'Перетащите заголовок столбца и отпустите его сюда, чтобы сгруппировать по этому критерию',
		'noRecords': 'Данные отсутствуют',
		'pagerFirstPage': 'Первая страница',
		'pagerPreviousPage': 'Предыдущую страница',
		'pagerNextPage': 'Следующая страница',
		'pagerLastPage': 'Последняя страница',
		'pagerPage': 'Страница',
		'pagerOf': 'из',
		'pagerItems': 'элементов',
		'pagerInfo': '{0} - {1} из {2}',
		'pagerItemsPerPage': 'На странице',
		'filterEqOperator': 'Равно',
		'filterNotEqOperator': 'Не равно',
		'filterIsNullOperator': 'Проверка на ноль',
		'filterIsNotNullOperator': 'Проверка не ноль',
		'filterIsEmptyOperator': 'Пустое значение',
		'filterIsNotEmptyOperator': 'Не пустое значение',
		'filterStartsWithOperator': 'Начать с',
		'filterContainsOperator': 'Содержит',
		'filterNotContainsOperator': 'Не содержит',
		'filterEndsWithOperator': 'Оканчивается на',
		'filterGteOperator': 'Больше или равно',
		'filterGtOperator': 'Больше чем',
		'filterLteOperator': 'Мельше или равно',
		'filterLtOperator': 'Меньше чем',
		'filterIsTrue': 'Правда',
		'filterIsFalse': 'Ложь',
		'filterBooleanAll': '(Все)',
		'filterAfterOrEqualOperator': 'Позже или равно',
		'filterAfterOperator': 'Позже',
		'filterBeforeOperator': 'Предыдущий',
		'filterBeforeOrEqualOperator': 'Раньше или равно',
		'filterFilterButton': 'Фильтр',
		'filterClearButton': 'Очистить фильтр',
		'filterAndLogic': '&&',
		'filterOrLogic': '||'
	}
}
loadMessages(esMessages, 'ru-RU')

Vue.component('Grid', Grid)

Vue.mixin({
	computed: {
		...mapState({
			$user: state => state.user.user
		})
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: `
		<LocalizationProvider :language="'ru-RU'">
			<App/>
		</LocalizationProvider>
	`,
	components: {
		App,
		LocalizationProvider
	}
})

Vue.component('app-link', {
	extends: Vue.component('router-link'),
	mounted () {
		// if (this._isDestroyed) return

		const toRoute = this.$router.matcher.match(this.to)

		for (const { meta: {roles, permissions} } of toRoute.matched) {
			let isProfilePage = toRoute.name === 'users-show' && this.$user && Number(toRoute.params.id) === this.$user.id

			let opt = (!toRoute.meta.showAll && !isProfilePage) ? ['show.admin-page.' + toRoute.name] : []
			if (roles) opt = [...opt, ...roles]
			if (permissions) opt = [...opt, ...permissions]

			if (opt.length && !this.$user.can(...opt)) {
				// this.$destroy()
				// this.$el && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
				this.$el.style.visibility = 'collapse'

				return
			}
		}
	}
})

Vue.directive('user-can', (el, { value }, vNode) => {
	const opt = typeof value === 'string' ? [value] : value
	if (!store.state.user.user.can(...opt)) {
			// replace HTMLElement with comment node
		const comment = document.createComment(' ')
		Object.defineProperty(comment, 'setAttribute', {
			value: () => undefined
		})
		vNode.elm = comment
		vNode.text = ' '
		vNode.isComment = true
		vNode.context = undefined
		vNode.tag = undefined
		vNode.data.directives = undefined

		if (vNode.componentInstance) {
			vNode.componentInstance.$el = comment
		}

		if (el.parentNode) {
			el.parentNode.replaceChild(comment, el)
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js